'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainStepController = function () {
  function MainStepController($stateParams, $translate, $state, $scope, hotkeys, $sce, $window) {
    'ngInject';

    _classCallCheck(this, MainStepController);

    angular.extend(this, { $state: $state, $scope: $scope, $sce: $sce, $window: $window });
    // Initialize
    this.uiOnParamsChanged($stateParams);
    // Copy translate's use method
    this.use = $translate.use;
    // Bind local method to this
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.current = this.current.bind(this);
    this.isFirst = this.isFirst.bind(this);
    this.isLast = this.isLast.bind(this);
    this.progress = this.progress.bind(this);
    this.current = this.current.bind(this);
    // Bind hot keys
    hotkeys.add({ combo: ['left'], callback: this.previous });
    hotkeys.add({ combo: ['space', 'right'], callback: this.next });
  }

  _createClass(MainStepController, [{
    key: 'uiOnParamsChanged',
    value: function uiOnParamsChanged(params) {
      this._step = Number(params.index || 0);
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.isLast()) {
        this.$state.go('main.step.outro');
      } else {
        this.$state.go('main.step', { index: this.step + 1 });
      }
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.isOutro()) {
        this.$state.go('main.step');
      } else if (this.isFirst()) {
        this.$state.go('main');
      } else if (this.step > 0) {
        this.$state.go('main.step', { index: this.step - 1 });
      }
    }
  }, {
    key: 'isFirst',
    value: function isFirst() {
      return this.step === 0;
    }
  }, {
    key: 'isLast',
    value: function isLast() {
      return this.step === this.meta.length - 1;
    }
  }, {
    key: 'isOutro',
    value: function isOutro() {
      return this.$state.is('main.step.outro');
    }
  }, {
    key: 'current',
    value: function current() {
      return this.meta[this.step];
    }
  }, {
    key: 'progress',
    value: function progress() {
      return (this.step + this.isOutro()) / this.meta.length * 100;
    }
  }, {
    key: 'trustAs',
    value: function trustAs() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HTML';
      var value = arguments[1];

      return this.$sce.trustAs(this.$sce[type], value);
    }
  }, {
    key: 'step',
    get: function get() {
      return this._step;
    }
  }, {
    key: 'location',
    get: function get() {
      return this.$window.location.href;
    }
  }]);

  return MainStepController;
}();

angular.module('app').component('main.step', {
  templateUrl: 'app/main/step/step.html',
  controller: MainStepController,
  bindings: {
    meta: '<'
  }
});